/**
 * user Normalizr Schema
 */

import { schema } from 'normalizr';

import roleMapping from './roleMapping';

const user = new schema.Entity(
    'users',
    {
        roleMappings: [roleMapping]
    },
    {
        idAttribute: 'email'
    }
);

export default user;
